import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import AccountCircle from '@material-ui/icons/Fullscreen';
import FsExit from '@material-ui/icons/FullscreenExit';
import CloseCircle from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {
  useStyles,
  Engines_zmap,
  isMobile,
  isLandscape
} from '../constants/config';
import Infodrawer from './infodrawer';
import InteractiveMap from './map';
import { useTheme } from '@material-ui/core/styles';
import { TweenLite, CSSPlugin, AttrPlugin, Power2 } from 'gsap/all';

const C = CSSPlugin;
const C2 = AttrPlugin;

const years = [
  '1920',
  '1930',
  '1940',
  '1950',
  '1960',
  '1970',
  '1980',
  '1990',
  '2000',
  '2010',
  '2020'
];
const drawerWidth = 120;

function Timeline(props) {
  const { container } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [infoOpen, setInfoOpen] = React.useState(false);
  const [fullScreen, setMode] = React.useState(false);
  const [selectedYear, setSelectedYear] = React.useState(0);
  const [selectedIndex, setSelectedIndex] = React.useState('');
  const [landscape, setLandscape] = React.useState(isLandscape());

  React.useEffect(() => {
    window.addEventListener('orientationchange', function() {
      setLandscape(window.screen.orientation.angle);
    });
  }, []);

  function moveTimeLine(increment) {
    const map = document.getElementById('map_container');
    const incrementWidth = map.offsetWidth / years.length;
    const time = Math.abs(selectedYear - increment) * 0.4;
    setSelectedYear(increment);
    let destination = -incrementWidth * increment + drawerWidth;

    if (destination < -(map.offsetWidth - window.innerWidth))
      destination = -(map.offsetWidth - window.innerWidth) - drawerWidth;

    TweenLite.to(map, time, {
      x: increment ? destination + drawerWidth : 0,
      ease: Power2.easeInOut
    });
  }

  Timeline.incrementTimeline = val => {
    if (!fullScreen) {
      let newYear;
      if (val > 0) {
        newYear = selectedYear + 1;
        if (newYear > 10) {
          TweenLite.set('#map_container', { x: '-=5' });
          return;
        }
      } else {
        newYear = selectedYear - 1;
        if (newYear < 0) {
          return;
        }
      }
      moveTimeLine(newYear);
    }
  };

  function handleDrawerToggle() {
    setMobileOpen(!mobileOpen);
  }

  function handleInfoToggle(index) {
    if (index) setSelectedIndex(index);
    else InteractiveMap.scream();
    setInfoOpen(!infoOpen);
  }

  function handleFullScreenToggle() {
    const map = InteractiveMap.getMap();
    // TweenLite.killTweensOf('#map_container');

    TweenLite.set('#map_container', { x: 0, y: 0, scale: 1 });
    map.resetZoom();
    setMode(!fullScreen);
    if (!fullScreen) {
      map.getRoot().attr('transform', 'translate(0,86)');
      TweenLite.set('#CLOUDS2', { y: 80 });

      // if (!isMobile()) {
      //   window.removeEventListener("wheel", handMouseWheel, {
      //     passive: true
      //   });
      // }
    } else {
      // if (!isMobile()) {
      //   window.addEventListener("wheel", handMouseWheel, {
      //     passive: true
      //   });
      // }
    }
  }

  function handleLinesToggle() {
    const map = InteractiveMap.getMap();
    map.hideline();
  }

  function handleReplay() {
    const map = InteractiveMap.getMap();
    map.replayAnimation();
  }
  const drawer = (
    <div>
      <div className={classes.toolbar} />
      <Divider />
      <List>
        {years.map((text, index) => (
          <ListItem
            button
            key={index}
            selected={selectedYear === index}
            className={classes.listItem}
            onClick={() => moveTimeLine(index)}
          >
            <ListItemText
              primary={
                <Typography
                  style={{
                    fontFamily: 'GEInspira',
                    fontSize: 'calc(16px + 1.5vh)',
                    padding: isMobile() ? 15 : 5,
                    paddingTop: isMobile() ? 15 : '1vh',
                    paddingBottom: isMobile() ? 15 : '1vh',
                    color: '#5270b5',
                    textAlign: 'center'
                  }}
                >
                  {text}
                </Typography>
              }
            />
            <Divider />
          </ListItem>
        ))}
        <ListItem button onClick={handleFullScreenToggle}>
          <ListItemText
            primary={
              <Typography
                style={{
                  fontFamily: 'GEInspira',
                  fontSize: '12px',
                  color: '#5270b5',
                  textAlign: 'center',
                  padding: isMobile() ? 15 : 5
                }}
              >
                FULL TIMELINE
              </Typography>
            }
          />
        </ListItem>
        <ListItem button onClick={handleReplay}>
          <ListItemText
            primary={
              <Typography
                style={{
                  fontFamily: 'GEInspira',
                  fontSize: '12px',
                  color: '#5270b5',
                  textAlign: 'center',
                  padding: isMobile() ? 15 : 5
                }}
              >
                REPLAY ANIMATION
              </Typography>
            }
          />
        </ListItem>
        <ListItem button onClick={handleLinesToggle}>
          <ListItemText
            primary={
              <Typography
                style={{
                  fontFamily: 'GEInspira',
                  fontSize: '12px',
                  color: '#5270b5',
                  textAlign: 'center',
                  padding: 5
                }}
              >
                HIDE LINES{' '}
              </Typography>
            }
          />
        </ListItem>
      </List>
    </div>
  );
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolBar}>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <img
            src="./images/logo.svg"
            className={classes.logo}
            alt="GE - Hertiage of Innovation Timeline"
          />
          <div>
            <IconButton
              aria-haspopup="true"
              color="inherit"
              onClick={handleFullScreenToggle}
            >
              {fullScreen ? <FsExit /> : <AccountCircle />}{' '}
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {fullScreen ? (
        ''
      ) : (
        <>
          <Hidden mdUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === 'rtl' ? 'right' : 'left'}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper
              }}
              ModalProps={{
                keepMounted: true // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden smDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper
              }}
              variant="permanent"
              ModalProps={{
                keepMounted: true // Better open performance on mobile.
              }}
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </>
      )}
      <Drawer
        container={document.getElementById('timeline-container')}
        variant="temporary"
        anchor={'right'}
        open={infoOpen}
        onClose={() => handleInfoToggle()}
        ModalProps={{
          container: document.getElementById('timeline-container'),
          disablePortal: true
        }}
        classes={{
          paper: classes.infoPaper
        }}
      >
        <div style={{ padding: 25, paddingTop: 60 }}>
          <IconButton
            onClick={() => handleInfoToggle()}
            className={classes.closeBtn}
          >
            <CloseCircle />
          </IconButton>
          <Infodrawer data={Engines_zmap[selectedIndex]} />
        </div>
      </Drawer>
      <div
        id="timeline-container"
        className={classes.timelineContainer}
        style={{
          marginLeft: fullScreen ? 0 : null,
          paddingTop: isMobile() && landscape ? 0 : null
        }}
      >
        <InteractiveMap
          fullScreen={fullScreen}
          infoOpen={handleInfoToggle}
          classes={classes.mapContainer}
        />
      </div>
    </div>
  );
}

const handleFirstInteraction = e => {
  const map = InteractiveMap.getMap();
  map.stopAnimation();
  window.removeEventListener('click', handleFirstInteraction);
  window.removeEventListener('mousedown', handleFirstInteraction, true);
  window.removeEventListener('wheel', handleFirstInteraction, true);
  window.removeEventListener('touchstart', handleFirstInteraction, true);
};

window.addEventListener('keydown', event => {
  if (event.key === 'ArrowLeft') Timeline.incrementTimeline(-1);
  if (event.key === 'ArrowRight') Timeline.incrementTimeline(1);
});

window.addEventListener('click', handleFirstInteraction);
window.addEventListener('touchstart', handleFirstInteraction, true);

window.addEventListener('mousedown', handleFirstInteraction, true);
window.addEventListener('wheel', handleFirstInteraction, true);

export default Timeline;
